import { useEffect, useState } from 'react';
import i18next from 'i18next';
import './OnboardingHint.css';

const SEEN_KEY = 'fab_hint_seen';

const OnboardingHint = () => {
  const [show, setShow] = useState(false);

  // First visit only: show the hint shortly after mount so the page/buttons render first.
  useEffect(() => {
    if (localStorage.getItem(SEEN_KEY) === '1') return undefined;
    const id = setTimeout(() => setShow(true), 600);
    return () => clearTimeout(id);
  }, []);

  // Lift + glow the real floating buttons in place while the hint is open.
  useEffect(() => {
    if (!show) return undefined;
    document.body.classList.add('fab-onboarding');
    return () => document.body.classList.remove('fab-onboarding');
  }, [show]);

  const dismiss = () => {
    localStorage.setItem(SEEN_KEY, '1');
    setShow(false);
  };

  if (!show) return null;

  return (
    <div
      className="fab-onboarding-backdrop"
      onClick={dismiss}
      role="dialog"
      aria-live="polite"
    >
      <div className="fab-onboarding__hint fab-onboarding__hint--right">
        <span>{i18next.t('这里有更多功能')}</span>
        <span className="fab-onboarding__arrow" aria-hidden="true">👇🏻</span>
      </div>
      <button
        type="button"
        className="fab-onboarding__dismiss"
        onClick={(e) => {
          e.stopPropagation();
          dismiss();
        }}
      >
        {i18next.t('知道了')}
      </button>
    </div>
  );
};

export default OnboardingHint;
